/* @flow */

import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';
import Button from '@material-ui/core/Button';

import ActionDrawerStore from 'stores/ActionDrawerStore';
import styles from 'views/ActionDrawer/ActionDrawer.module.scss';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import UserStore from 'stores/UserStore';

export type ActionDrawerFormButtonsProps = {
  form: Object,
  submitTxt: boolean,
  disabled?: boolean,
};

type InjectedProps = {
  actionDrawerStore: ActionDrawerStore,
  userStore: UserStore,
} & TranslatorProps;

@translate()
@inject('actionDrawerStore', 'userStore')
@observer
export default class ActionDrawerFormButtons extends ComponentWithInjectedProps<
  ActionDrawerFormButtonsProps,
  {},
  InjectedProps
> {
  render() {
    const {
      t,
      form,
      submitTxt,
      actionDrawerStore,
      disabled,
      userStore: { isReadOnly },
    } = this.props;

    return (
      <div className={styles['action-drawer-actions']}>
        <Button variant="contained" onClick={() => actionDrawerStore.closeActionDrawer()}>
          {t('general:actions.cancel')}
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          onClick={form.onSubmit}
          disabled={disabled || isReadOnly}
        >
          {submitTxt}
        </Button>
      </div>
    );
  }
}
